
import React, { useState } from 'react';

const Consensus = (props) => {
    const [obs, setObs] = useState('')
    const [point, setPoint] = useState(props?.data?.point ? parseInt(props.data.point) : 0)

    return (
        <div className='flex flex-col p-4'>
            <p className='font-bold text-[1.2em]'>Consenso</p>
            <div className='flex flex-col w-full mt-4'>
                <span>Observação</span>
                <textarea
                    placeholder='Observação sobre o consenso'
                    className='p-2 border rounded'
                    onChange={(e) => {
                        setObs(e.target.value)
                    }}
                >{obs}</textarea>
            </div>
            <div className='flex flex-col w-full mt-4'>
                <span>Ajustar pontuação</span>
                <input
                    className='p-2 border rounded'
                    type='number'
                    min={-100}
                    max={100}
                    value={point}
                    step={1}
                    onChange={(e) => {
                        setPoint(parseInt(e.target.value))
                    }}
                />
            </div>
            <button
                className='py-2 flex justify-center px-4 bg-blue-900 text-white rounded font-bold cursor-pointer mt-4'
                onClick={()=>{
                    if(obs === ''){
                        return alert('Preencha a observação.')
                    }
                    if(obs.length < 10){
                        return alert('Observação muito pequena, coloque uma observação maior.')
                    }

                    if(props?.onSave){
                        props.onSave({
                            active: true,
                            obs, 
                            point,
                            valuer: {
                                name: props.loggedUser.nome,
                                level: props.loggedUser.nivel,
                                id: props.loggedUser.id,
                            }
                        })
                    }
                }}
            >Salvar consenso</button>
        </div>
    );
};

export default Consensus;

